import { $digitalProperty } from '../constants/digital-properties';
import { IDigitalProperty, IDigitalPropertyListItem } from '../interfaces/digital-property.interface';

export class DigitalPropertyCollisionUtility {
  static hasNameCollision(
    digitalProperty: IDigitalProperty | IDigitalPropertyListItem,
    otherProperties: Array<IDigitalProperty | IDigitalPropertyListItem>,
  ): boolean {
    return Boolean(
      otherProperties?.some((dp: IDigitalProperty) => dp[$digitalProperty.name] === digitalProperty?.[$digitalProperty.name]),
    );
  }

  static hasKeyCollision(
    digitalProperty: IDigitalProperty | IDigitalPropertyListItem,
    otherProperties: Array<IDigitalProperty | IDigitalPropertyListItem>,
  ): boolean {
    return Boolean(
      otherProperties?.some(
        (dp: IDigitalProperty) => dp[$digitalProperty.propertyKey] === digitalProperty?.[$digitalProperty.propertyKey],
      ),
    );
  }
}
